import {FETCH_BASKET_VOUCHERS, GET_USER_POINTS} from 'services/campaign/queries';
import {BasketVoucherDetails, FetchBasketVouchersQuery, GetUserPointsResponse} from 'types/campaign';
import {campaignGraphqlRequest} from 'utils/graphqlRequests';

export const fetchBasketVouchers = async (variables: FetchBasketVouchersQuery) => {
  const result = await campaignGraphqlRequest(FETCH_BASKET_VOUCHERS, variables);
  return result.fetchBasketVouchers as BasketVoucherDetails;
};

export const fetchUserPoints = async () => {
  const result = await campaignGraphqlRequest(GET_USER_POINTS, {});
  return result.getPoints as GetUserPointsResponse;
};
